import Hubspot from '@clearkit/icons/services/Hubspot';
import Salesforce from '@clearkit/icons/services/Salesforce';

export const typePerson = 'person';
export const typeCompany = 'company';

export const integrationTypeSalesforce = 'salesforce';
export const integrationTypeHubSpot = 'hubspot';

const types = {
  salesforce: 'salesforce',
  hubspot: 'hubspot',
};

export const statuses = {
  complete: 'complete',
  error: 'error',
  info: 'info',
  pending: 'pending',
  skipped: 'skipped',
};

export const filters = {
  all: 'all',
  complete: 'complete',
  incomplete: 'incomplete',
};

export const subTypes = {
  account: 'account',
  contact: 'contact',
  lead: 'lead',
};

export function filterToStatuses(filter) {
  switch (filter) {
    case filters.complete:
      return [statuses.complete, statuses.error, statuses.info];
    case filters.incomplete:
      return [statuses.pending, statuses.processing];
  }
}

export function readableFilter(filter) {
  switch (filter) {
    case filters.all:
      return 'enrichments';
    case filters.complete:
      return 'complete enrichments';
    case filters.incomplete:
      return 'incomplete enrichments';
  }
}

export function readableType(type) {
  switch (type) {
    case types.salesforce:
      return 'Salesforce';
    case types.hubspot:
      return 'HubSpot';
  }
}

export function sourceIcon(type, pixels = 18) {
  switch (type) {
    case 'salesforce':
      return <Salesforce width={pixels} height={pixels} />;
    case 'hubspot':
      return <Hubspot width={pixels} height={pixels} />;
  }
}

export const objectTypeAccount = { name: 'account', type: typeCompany };
export const objectTypeCompany = { name: 'company', type: typeCompany };
export const objectTypeContact = { name: 'contact', type: typePerson };
export const objectTypeLead = { name: 'lead', type: typePerson };

export const integrationTypes = [
  integrationTypeSalesforce,
  integrationTypeHubSpot,
];
export const objectTypes = {
  [integrationTypeSalesforce]: [
    objectTypeAccount,
    objectTypeContact,
    objectTypeLead,
  ],
  [integrationTypeHubSpot]: [objectTypeContact, objectTypeCompany],
};

export const findAttribute = (value, attributes) => {
  if (!value) {
    return null;
  }

  for (let index = 0; index < attributes.length; index++) {
    const attribute = attributes[index];

    if (
      attribute.value === value.value &&
      attribute.meta.objectType === value.objectType &&
      attribute.meta.sourceType === value.sourceType
    ) {
      return attribute;
    }

    if (attribute.children && attribute.children.length > 0) {
      const foundAttribute = findAttribute(value, attribute.children);

      if (foundAttribute) {
        return foundAttribute;
      }
    }
  }
};

export const attributeForFinder = (mapping, sourceOrTarget) => {
  return {
    value: mapping[`${sourceOrTarget}Field`],
    objectType: mapping[`${sourceOrTarget}ObjectType`],
    sourceType: mapping[`${sourceOrTarget}Type`],
  };
};

export const backendSupportedDataType = (type) => {
  switch (type) {
    case 'boolean':
      return 'bool';
    default:
      return type;
  }
};
